import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { InstallationItem } from '../../../models/installation-item.model'

@Component({
    selector: 'app-customer-relations-presenter',
    templateUrl: './customer-relations-presenter.component.html',
    styleUrls: ['./customer-relations-presenter.component.scss'],
    standalone: false,
})
export class CustomerRelationsPresenterComponent {
    @Input() public isInToolbar = false
    @Input() public showAddCustomerRelationButton = true
    @Input() public isExpanded = false
    @Input() public showSummary = true
    @Input() public canToggle = false
    @Input() public isBusiness = false
    @Input() public selectedItem: InstallationItem = null
    @Input() public installations: InstallationItem[] = []
    @Input() public formGroup: UntypedFormGroup
    @Input() public isSingleInstallationView = false

    @Output() public toggleExpand = new EventEmitter<void>()
    @Output() public addCustomerRelation = new EventEmitter<void>()
    @Output() public selectInstallation = new EventEmitter<InstallationItem>()

    public onToggleExpand(): void {
        this.toggleExpand.emit()
    }

    public onAddCustomerRelation(): void {
        this.addCustomerRelation.emit()
    }

    public onSelectInstallation(installation: InstallationItem): void {
        this.selectInstallation.emit(installation)
    }
}
